module.exports = __webpack_public_path__ + "img/produto-duo.f4f4e356.png";